import { Observable } from 'rxjs';

export type Lookup<TLookup, TValue> = { [key in keyof TLookup]: TValue };

export function createLookup<TKey, TValue>(keys: TKey, valueFn: (key: keyof TKey) => TValue) {
  const result: any = {};
  // eslint-disable-next-line guard-for-in
  for (const key in keys) {
    result[key] = valueFn(key);
  }
  return result;
}

export type ObservableLookup<TLookup, TValue> = Lookup<TLookup, { $: Observable<TValue> }>;

export function createObservableLookup<TLookup, TValue>(
  keys: TLookup,
  valueFn: (key: keyof TLookup) => Observable<TValue>,
): ObservableLookup<TLookup, TValue> {
  const result: any = {};
  // eslint-disable-next-line guard-for-in
  for (const key in keys) {
    result[key] = { $: valueFn(key) };
  }
  return result;
}

export function createPartialLookupFactory<TKeys extends string, TValue = any>() {
  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  return function <T extends { [key in TKeys]?: TValue }>(factory: T) {
    return factory;
  };
}

export function createExhaustiveLookupFactory<TKeys extends string, TValue = any>() {
  // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
  return function <T extends { [key in TKeys]: TValue }>(factory: T) {
    return factory;
  };
}
